type contentBlockType = "email" | "web";

const enum storageKey {
    isContentBlockContext = "isContentBlockContext",
    contentBlockContextType = "contentBlockContextType",
}

export function isContentBlockContext(): boolean {
    return (
        window.sessionStorage.getItem(storageKey.isContentBlockContext) === "1"
    );
}

export function setContentBlockContext(contentBlockPath: string) {
    const isContentBlockContext =
        window.location.pathname.startsWith(contentBlockPath);
    window.sessionStorage.setItem(
        storageKey.isContentBlockContext,
        isContentBlockContext ? "1" : "0"
    );

    const type: contentBlockType = window.location.pathname.includes("/email")
        ? "email"
        : "web";

    window.sessionStorage.setItem(storageKey.contentBlockContextType, type);
}

export function getContentBlockType(): contentBlockType | undefined {
    const type = window.sessionStorage.getItem(
        storageKey.contentBlockContextType
    );
    if (!type) {
        return;
    }

    return type as contentBlockType;
}
